module.exports = __webpack_public_path__ + "static/media/calculatemi.ae72c353.svg";